import { render, staticRenderFns } from "./CentroLogo.vue?vue&type=template&id=1dd32048"
import script from "./CentroLogo.vue?vue&type=script&lang=js"
export * from "./CentroLogo.vue?vue&type=script&lang=js"
import style0 from "./CentroLogo.vue?vue&type=style&index=0&id=1dd32048&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports